import {ImageWithFallback} from "@/components";

export default function CompletedProjectCard({image, title, link = "", alt = "", parentClasses = ""}) {
    return (
        <a href={link}
           target="_blank"
           rel="noopener noreferrer"
           className={`block relative rounded-t-[2.25rem] rounded-br-[2.25rem] rounded-bl-3xl overflow-hidden w-full h-[252px] lg:h-full ${parentClasses}`}
        >
            <div className="relative w-full h-full">
                <ImageWithFallback
                    src={image}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    fill
                    alt={alt || title}
                    className="object-cover"
                />
            </div>
            <div className="absolute left-[0.938rem] bottom-[0.938rem] rounded-xl bg-pol-dark-2/40 p-2">
                <p className="font-semibold text-white text-[0.938rem]">
                    <i className="icon-hashtag ml-1.5"/>
                    {title}
                </p>
            </div>
        </a>
    )
}
